<template>
    <div
        :class="[
            {
                'has-inline-label': hasInlineLabel,
                'has-placeholder': !!placeholder,
            },
            parentClass,
        ]"
        class="form-group"
    >
        <label
            :for="uniqueId"
            :class="[
                {
                    'move-label-to-top': moveLabelToTop,
                },
                'form-label',
            ]"
        >
            {{ label }}
        </label>
        <textarea
            v-model="inputValue"
            v-bind="$attrs"
            @focusin="focus = true"
            @focusout="focus = false"
            @input="handleInput"
            :id="uniqueId"
            :placeholder="inputPlaceholder"
            :rows="rows"
            :class="[
                {
                    'move-label-to-top': moveLabelToTop,
                },
                'form-control',
            ]"
        ></textarea>
        <slot />
    </div>
</template>

<script>
    import Config from '../../config';

    export default {
        name: 'FormTextarea',
        inheritAttrs: false,
        props: {
            value: {
                type: [String, Number],
                default: '',
            },
            label: {
                required: true,
                type: String,
            },
            placeholder: {
                type: String,
                default: '',
            },
            parentClass: {
                type: String,
                default: '',
            },
            inlineLabel: {
                type: Boolean,
                default: Config.options.inlineLabel,
            },
            rows: {
                type: Number,
                default: 3,
            },
        },
        data() {
            return {
                focus: false,
                inputValue: null,
                hasInlineLabel: this.inlineLabel,
            };
        },
        computed: {
            moveLabelToTop() {
                return this.placeholder || this.focus || this.inputValue !== '';
            },
            uniqueId() {
                return this.$id('pacos-input');
            },
            inputPlaceholder() {
                return this.hasInlineLabel
                    ? this.placeholder || this.label
                    : this.placeholder;
            },
        },
        methods: {
            handleInput() {
                this.$emit('input', this.inputValue);
            },
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    this.inputValue = value;
                },
            },
        },
    };
</script>
